/**
 * Represents a phone anchor for call tracking.
 */
export default class PhoneAnchorCallTracking {
  /**
   * Creates a new instance of PhoneAnchorCallTracking.
   */
  constructor() {
    this.anchorId = 'nhs_phoneCallTrackingAnchor';
  }

  /**
   * Sets the phone number for the anchor.
   * @param {string} phoneNumber - The phone number to set.
   */
  setPhoneNumber(phoneNumber) {
    this.phoneNumber = phoneNumber.replaceAll('-', '');
    this.userFriendlyPhone = phoneNumber;
  }

  /**
   * Binds events to the PhoneAnchorCallTracking component.
   * @function bindEvents
   * @memberof PhoneAnchorCallTracking
   * @instance
   */
  bindEvents() {
    const anchor = this.getAnchor();
    anchor?.addEventListener('click', ()=> document.body.dispatchEvent(new CustomEvent('phoneAnchorTrackingClick')));
  }
  
  /**
   * Gets the phone anchor element.
   * @returns {HTMLElement} - The phone anchor element.
   */
  getPhoneAnchor() {
    return document.getElementById(this.anchorId);
  }

  /**
   * Returns the phone anchor.
   * @returns {string} The phone anchor.
   */
  getAnchor() {
    return this.getPhoneAnchor();
  }

  /**
   * Gets the HTML for the phone anchor.
   * @returns {string} - The HTML for the phone anchor.
   */
  getHtml() {
    if (!this.phoneNumber) {
      return '';
    }

    return `
    <a id="${this.anchorId}" href="tel:${this.phoneNumber}" data-close class="btn btn--yellow btn--48-lg" data-qa="CallBuilder">
      Don’t Miss Out!<br> ${this.userFriendlyPhone}
    </a>`;
  }
}
